import { createSlice } from '@reduxjs/toolkit'

export const typesSlice = createSlice({
  name: 'entryTypes',
  initialState: [],
  reducers: {},
})

const { actions, reducer } = typesSlice
export const entryTypesActions = actions
export const entryTypesReducer = reducer
